import type { DropdownOption } from './dropdown';

export function toPersonDropdownOptions(
  persons: ReadonlyArray<{ id: string; firstName: string; lastName: string; profilePicture?: string | null }>
): DropdownOption[] {
  return persons.map(person => {
    const fullName = `${person.lastName} ${person.firstName}`;
    const picture = person.profilePicture ?? undefined;
    return { label: fullName, value: person.id, avatarName: fullName, avatarSrc: picture, imageUrl: picture };
  });
}
